<template lang="pug">
.homepageSection8Component#purchase
  .sectionContainer
    .left
      .title Подготовьтесь к первому учебному году Вашего ребенка сейчас!
    .right
      .panel
        ui-price(
          variant="main"
          :text="data.text"
          :price="data.price"
          :old-price="data.oldPrice"
        )
        .buttons
          purchase-buttons-block(is-last-section)
</template>

<script>
import homepageData from '@/mocks/homepage.json'
import PurchaseButtonsBlock from './PurchaseButtonsBlock/PurchaseButtonsBlock'

export default {
  components: {
    PurchaseButtonsBlock
  },
  setup () {
    const data = homepageData.section8

    return {
      data
    }
  }
}
</script>

<style lang="sass" scoped>
.homepageSection8Component
  background: #ECF4F9
  > .sectionContainer
    display: grid
    grid-template-columns: 1fr 1fr
    grid-gap: 2*$appSidePaddingDesktop

    > .left
      > .title
        font-family: GolosTextWebBold, serif
        font-style: normal
        font-weight: bold
        font-size: 42px
        line-height: 130%
        color: $cDarkBlue

    > .right
      > .panel
        background: #FFFFFF
        border-radius: 20px
        padding: 7*$u 10*$u 9*$u

        > .buttons
          margin-top: 6*$u

  @media (max-width: $XXXLWidth)
    > .sectionContainer
      grid-gap: $appSidePaddingDesktop
  @media (max-width: 1040px)
    > .sectionContainer
      > .left
        > .title
          font-size: 26px

      > .right
        > .panel
          > .title
            font-size: 26px

  @media (max-width: $padWidth)
    > .sectionContainer
      grid-template-columns: 1fr
    > .sectionContainer
      > .left
        > .title
          text-align: center

  @media (max-width: $XXSWidth)
    > .sectionContainer
      > .right
        > .panel
          padding-left: $appSidePaddingMobile
          padding-right: $appSidePaddingMobile
</style>
